import commonService from "../../common";

export const calTotal = (bookGroup) => {
  var total = 0;
  commonService.sort(bookGroup.books).forEach((book) => {
    if (book.price) {
      total = total + book.price.price;
    }
  });
  return total;
};
